import { 
    IDrugTestReport, 
    ICourtAttendanceReport, 
    IPhaseReportParamter, 
    IFiscalYearReportSearch,
    ITreatmentReport, 
    ICaseManagementReport, 
    IAncillaryMeetingReport,
    ISupervisionReport, 
    ISupervisionContactReport, 
    IParticipantDrugTestReport, 
    IAncillaryServiceReport, 
    IServiceUnitReport, 
    IProgramServedReport, 
    IProgramTerminationReport, 
    IProgramGraduationReport, 
    IProgramDrugTestReport, 
    IProgramDrugsFoundReport, 
    IRetentionRateReport, 
    IInProgramRecidivismReport, 
    IPostProgramRecidivismReport, 
    IArrestSummary,
    IUniqueParticipantReport, 
    ICensusReport,
    IEconomicReport, 
} from '@/Models/Report/IPhaseReport';
import { BaseApiService } from '@/Services/base-api-service';
import { 
    IBehaviorMetricReport, 
    ICourtAppearanceMetricReport, 
    IDrugTestMetricReport, 
    IJudicialHistoryMetricReport, 
    IMetricReport, 
    IProgramGoalMetricReport, 
} from '@/Models/Report/IMetricReport';
import { ProgramHistoryMetricReportDto } from '@/Models/Report/IProgramReport';

class reportService extends BaseApiService {
    public constructor() {
		super('Report/');
    }

    public async getDrugTestReportData(params: IPhaseReportParamter): Promise<IDrugTestReport[]> {
        return this.httpClient.post<IDrugTestReport[]>(`GetDrugTestReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getCourtAttendanceReportData(params: IPhaseReportParamter): Promise<ICourtAttendanceReport[]> {
        return this.httpClient.post<ICourtAttendanceReport[]>(`GetCourtAttendanceReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getCensusReportData(params: IPhaseReportParamter): Promise<ICensusReport[]> {
        return this.httpClient.post<ICensusReport[]>('GetCensusReportData', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getMetricsReportData(params: IPhaseReportParamter): Promise<IMetricReport[]> {
        return this.httpClient.post<IMetricReport[]>('GetMetricReportData', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getDrugTestMetricReportData(params: IPhaseReportParamter): Promise<IDrugTestMetricReport[]> {
        return this.httpClient.post<IDrugTestMetricReport[]>('GetDrugTestMetrics', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getCourtAppearanceMetricReportData(params: IPhaseReportParamter): Promise<ICourtAppearanceMetricReport[]> {
        return this.httpClient.post<ICourtAppearanceMetricReport[]>('GetCourtAppearanceMetrics', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getProgramGoalMetricReportData(params: IPhaseReportParamter): Promise<IProgramGoalMetricReport[]> {
        return this.httpClient.post<IProgramGoalMetricReport[]>('GetProgramGoalMetrics', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getBehaviorMetricReportData(params: IPhaseReportParamter): Promise<IBehaviorMetricReport[]> {
        return this.httpClient.post<IBehaviorMetricReport[]>('GetBehaviorMetrics', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getJudicialHistoryMetricReportData(params: IPhaseReportParamter): Promise<IJudicialHistoryMetricReport[]> {
        return this.httpClient.post<IJudicialHistoryMetricReport[]>('GetJudicialHistoryMetrics', params)
                    .then(this.handleResponse.bind(this))
                    .catch(this.handleError.bind(this));
    }

    public async getTreatmentReportData(params: IPhaseReportParamter): Promise<ITreatmentReport[]> {
        return this.httpClient.post<ITreatmentReport[]>(`GetTreatmentReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getCaseManagementReportData(params: IPhaseReportParamter): Promise<ICaseManagementReport[]> {
        return this.httpClient.post<ICaseManagementReport[]>(`GetCaseManagementReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getAncillaryMeetingReportData(params: IPhaseReportParamter): Promise<IAncillaryMeetingReport[]> {
        return this.httpClient.post<IAncillaryMeetingReport[]>(`GetAncillaryMeetingReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getSupervisionReportData(params: IPhaseReportParamter): Promise<ISupervisionReport[]> {
        return this.httpClient.post<ISupervisionReport[]>(`GetSupervisionReportData`, params)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getSupervisionContactReportData(searchDto: IFiscalYearReportSearch): Promise<ISupervisionContactReport[]> {
        return this.httpClient.post<ISupervisionContactReport[]>("GetSupervisionContactReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getParticipantDrugTestReportData(searchDto: IFiscalYearReportSearch): Promise<IParticipantDrugTestReport[]> {
        return this.httpClient.post<IParticipantDrugTestReport[]>("GetParticipantDrugTestReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getAncillaryServiceReportData(searchDto: IFiscalYearReportSearch): Promise<IAncillaryServiceReport[]> {
        return this.httpClient.post<IAncillaryServiceReport[]>("GetAncillaryServiceReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getServiceUnitReportData(searchDto: IFiscalYearReportSearch): Promise<IServiceUnitReport[]> {
        return this.httpClient.post<IServiceUnitReport[]>("GetServiceUnitReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getProgramServedReportData(searchDto: IFiscalYearReportSearch): Promise<IProgramServedReport[]> {
        return this.httpClient.post<IProgramServedReport[]>("GetProgramServedReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getProgramTerminationReportData(searchDto: IFiscalYearReportSearch): Promise<IProgramTerminationReport[]> {
        return this.httpClient.post<IProgramTerminationReport[]>("GetProgramTerminationReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getProgramGraduationReportData(searchDto: IFiscalYearReportSearch): Promise<IProgramGraduationReport[]> {
        return this.httpClient.post<IProgramGraduationReport[]>("GetProgramGraduationReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getProgramDrugTestReportData(searchDto: IFiscalYearReportSearch): Promise<IProgramDrugTestReport[]> {
        return this.httpClient.post<IProgramDrugTestReport[]>("GetProgramDrugTestReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getProgramDrugsFoundReportData(searchDto: IFiscalYearReportSearch): Promise<IProgramDrugsFoundReport[]> {
        return this.httpClient.post<IProgramDrugsFoundReport[]>("GetProgramDrugsFoundReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getRetentionRateReportData(searchDto: IFiscalYearReportSearch): Promise<IRetentionRateReport[]> {
        return this.httpClient.post<IRetentionRateReport[]>("GetRetentionRateReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getInProgramRecidivismReportData(searchDto: IFiscalYearReportSearch): Promise<IInProgramRecidivismReport[]> {
        return this.httpClient.post<IInProgramRecidivismReport[]>("GetInProgramRecidivismReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getPostProgramRecidivismReportData(searchDto: IFiscalYearReportSearch): Promise<IPostProgramRecidivismReport[]> {
        return this.httpClient.post<IPostProgramRecidivismReport[]>("GetPostProgramRecidivismReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getInProgramRecidivismSummaryReportData(searchDto: IFiscalYearReportSearch): Promise<IArrestSummary[]> {
        return this.httpClient.post<IArrestSummary[]>("GetInProgramRecidivismSummaryReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getPostProgramRecidivismSummaryReportData(searchDto: IFiscalYearReportSearch): Promise<IArrestSummary[]> {
        return this.httpClient.post<IArrestSummary[]>("GetPostProgramRecidivismSummaryReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async getUniqueParticipantReportData(searchDto: IFiscalYearReportSearch): Promise<IUniqueParticipantReport[]> {
        return this.httpClient.post<IUniqueParticipantReport[]>("GetUniqueParticipantReportData", searchDto)
            .then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

	public async getProgramHistoryReportData(params: IPhaseReportParamter): Promise<ProgramHistoryMetricReportDto> {
		return this.httpClient.post<ProgramHistoryMetricReportDto>('GetProgramHistoryMetricReportData', params)
			.then(this.handleResponse.bind(this))
			.catch(this.handleError.bind(this))
	}

    public async getEconomicReportData(params: IPhaseReportParamter): Promise<IEconomicReport[]> {
        return this.httpClient.post<IEconomicReport[]>("GetEconomicReportData", params)
               .then(this.handleResponse.bind(this))
               .catch(this.handleError.bind(this))
    }
}

export const ReportService: reportService = new reportService();